import { Theme, Typography, styled } from '@material-ui/core';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import React, { FC } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks/useAppDispatch';
import { setSelectedEntry } from '../../slices/debugToolbar/debugToolbarSlice';

export const StyledDiv = styled('div')<Theme, { color: string }>(({ theme, color }) => ({
  display: 'flex',
  flexDirection: 'row',
  padding: '0 0 0 1rem',
  justifyContent: 'flex-start',
  gap: '2rem',
  alignItems: 'center',
  background: color,
}));

const DebugToolbar: FC = () => {
  const active = useAppSelector((state) => state.debugToolbar.active);
  const title = useAppSelector((state) => state.debugToolbar.title);
  const toggleEntries = useAppSelector((state) => state.debugToolbar.toggleEntries);
  const selectedEntry = useAppSelector((state) => state.debugToolbar.selectedEntry);
  const color = useAppSelector((state) => state.debugToolbar.color);
  const dispatch = useAppDispatch();

  if (!active) return null;
  return (
    <StyledDiv color={color}>
      <Typography variant="h3" key={'title-debugToolbar'}>
        {title}
      </Typography>
      <ToggleButtonGroup
        value={selectedEntry}
        onChange={(_, value) => {
          dispatch(setSelectedEntry(value));
        }}
        exclusive
      >
        {toggleEntries.map((elem: any) => (
          <ToggleButton
            style={{ color: 'white' }}
            className={elem.value === selectedEntry ? 'selected' : ''}
            value={elem.value}
            key={elem.value}
          >
            {elem.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </StyledDiv>
  );
};

export default DebugToolbar;
